var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = '${{amount}}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, true);
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, false);
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return ['blur', 'error', 'focus', 'load', 'resize', 'scroll'].indexOf(eventType) !== -1;
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError('Invalid event type: ' + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === 'function') {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== 'function') {
    throw new TypeError('Handler must be a type of Function');
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, useCapture);
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === 'function') {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = 'ftLabsDelegateIgnore';

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ['button', 'input', 'select', 'textarea'].indexOf(target.tagName.toLowerCase()) > -1 &&
        target.hasAttribute('disabled')
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class Popup {
  constructor(element) {
    this.element = element;

    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector('.pageOverlay');
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on('click', '[data-action="open-modal"]', this.openModal.bind(this));
    this.delegateElement.on('click', '[data-action="close-modal"]', this.closeModal.bind(this));
    this.delegateElement.on('click', '[data-action="delete-address"]', this.deleteAddress.bind(this));

    document.addEventListener('posted_successfully', this.openModalSpecial.bind(this));

    //this.pageOverlayElement.addEventListener("click", this.closeModal(this.activeModal));
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add('is-visible');
    this.activeModal = document.getElementById(event.target.getAttribute('aria-controls'));
    this.activeModal.setAttribute('aria-hidden', 'false');

    var focus = this.element.querySelector('[data-scrollable]');
    bodyScrollLock.disableBodyScroll(focus);
  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add('is-visible');
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute('aria-hidden', 'false');
    var focus = this.element.querySelector('[data-scrollable]');
    bodyScrollLock.disableBodyScroll(focus);
  }
  closeModal(modal) {
    var focus = this.element.querySelector('[data-scrollable]');
    bodyScrollLock.enableBodyScroll(focus);
    this.activeModal = modal;
    this.pageOverlayElement.classList.remove('is-visible');
    this.activeModal = document.getElementById(event.target.getAttribute('aria-controls'));
    this.activeModal.setAttribute('aria-hidden', 'true');
    this.activeModal.removeAttribute('style');
  }

  deleteAddress(event) {
    event.preventDefault();
    const id = event.target.getAttribute('data-id');

    Shopify.postLink('/account/addresses/' + id, {
      parameters: { _method: 'delete' },
    });
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="open-product-zoom"]', this.initPhotoSwipe.bind(this));
    this.delegateElement.on('click', '.ProductSliderCell--Zoom', this.initPhotoSwipeFromImageClick.bind(this));
    this.delegateRoot.on('pswpTap', '.pswp__button--close', this.photoswiperClose.bind(this));
  }

  photoswiperClose() {
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove('pswp-open-in-ios');
    }
    this.photoSwipeInstance.close;
  }

  destroy() {
    this.delegateElement.off('click');
  }

  initPhotoSwipe() {
    var images = [];
    this.slideshow.swiperElement.slides.forEach(function (item) {
      if (item.classList.contains('ProductSliderCell')) {
        if (item.querySelector('img')) {
          images.push(item.querySelector('img'));
        }
      }
    });

    var index_currentSlide = this.slideshow.swiperElement.realIndex;
    console.log(index_currentSlide);
    this.createPhotoSwipeInstance(this.createPhotoSwipeItemsFromImages(images), index_currentSlide);
  }

  initPhotoSwipeFromImageClick(event, target) {
    var _this = this;
    if (new Responsive().matchesBreakpoint('pocket')) {
      return;
    }
    var images = [];

    new DomHelper().getSiblings(target, null, true).forEach(function (item) {
      if (item.classList.contains('ProductSliderCell')) {
        if (item.querySelector('img')) {
          images.push(item.querySelector('img'));
        }
      }
    });

    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(target.querySelector('.ProductSlider--Element').getAttribute('data-image-position'))
    );
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute('data-max-width')),
        maxHeight = parseInt(image.getAttribute('data-max-height')),
        maxDimension = new Responsive().matchesBreakpoint('phone') ? 1200 : 2200,
        reduceFactor = 1.0;
      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: new Image().getSizedImageUrl(image.getAttribute('data-original-src'), requestedWidth + 'x' + requestedHeight),
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector('.pswp');
    this.photoSwipeInstance = new PhotoSwipe(photoswipeContainer, false, items, {
      index: selectedImageIndex,
      showHideOpacity: true,
      showAnimationDuration: 600,
      loop: true,
      history: false,
      closeOnVerticalDrag: true,
      allowPanToNext: false,
      pinchToClose: false,
      errorMsg: '<p class="pswp__error-msg"></p>',
      scaleMode: 'orig',
      getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
        if (isMouseClick) {
          return 1.15;
        } else {
          return item.initialZoomLevel < 0.7 ? 1 : 1.33;
        }
      },
      getThumbBoundsFn: function getThumbBoundsFn(index) {
        if (items.length > 1) {
          var thumbnail = _this.element.querySelector('.mainSwiper .ProductSliderCell--Zoom:nth-child(' + (parseInt(index) + 1) + ') img'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
    });

    this.photoSwipeInstance.listen('beforeChange', this.onSlideChanged.bind(this));
    this.photoSwipeInstance.listen('destroy', this.destroyPhotoSwipe.bind(this));
    this.photoSwipeInstance.listen('doubleTap', this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen('initialZoomIn', this.onInitialZoomIn.bind(this));
    this.photoSwipeInstance.listen('initialZoomOut', this.onInitialZoomOut.bind(this));
    this.photoSwipeInstance.listen('close', this.photoswiperClose.bind(this));

    this.delegateRoot.on('pswpTap', '.pswp__scroll-wrap', this.onSingleTap.bind(this));
    this.delegateRoot.on('pswpTap', '.pswp__button--close', this.photoSwipeInstance.close);
    this.delegateRoot.on('pswpTap', '.pswp__button--prev', this.photoSwipeInstance.prev);
    this.delegateRoot.on('pswpTap', '.pswp__button--next', this.photoSwipeInstance.next);

    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add('pswp-open-in-ios');
    }

    this.photoSwipeInstance.init();
  }

  onSlideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--prev').setAttribute('disabled', 'disabled');
    } else {
      this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--prev').removeAttribute('disabled');
    }

    if (this.photoSwipeInstance.getCurrentIndex() + 1 === this.photoSwipeInstance.options.getNumItemsFn()) {
      this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--next').setAttribute('disabled', 'disabled');
    } else {
      this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--next').removeAttribute('disabled');
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === 'mouse') {
      if (event.target.classList.contains('pswp__img')) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains('pswp__button')) {
        return;
      }

      event.target.closest('.pswp').querySelector('.pswp__ui').classList.toggle('pswp__ui--hidden');
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
    }
  }

  onInitialZoomIn() {
    document.querySelector('.pswp__ui').classList.remove('pswp__ui--hidden');
  }
  onInitialZoomOut() {
    document.querySelector('.pswp__ui').classList.add('pswp__ui--hidden');
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off('pswpTap');
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element) {
    this.element = element;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.mainDropdown = this.element.querySelector('.RevolutionDropdown--Content');
    this.mainButton = this.element.querySelector('.RevolutionDropdown--Button');
    this.connectedSelect = this.element.getAttribute('data-select');
    this.selectbox = this.element.querySelector('[name=' + this.connectedSelect + ']');
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector('[name2=' + this.connectedSelect + ']');
    }
    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);

    this.domDelegate.on('click', '[data-action=toggle-selectbox]', this.toggleDropdown.bind(this));

    this.domDelegate.on('click', '[data-action=selectbox-submit]', this.selectboxSubmit.bind(this));

    this.domDelegate.on('click', '[data-action=selectbox-change]', this.selectboxChange.bind(this));

    this.domDelegate.on('click', '[data-action=special-close]', this.toggleDropdown.bind(this));
    this.domDelegate.on('click', 'body', this.onClickOutside.bind(this));
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (!withinBoundaries) {
      this.closeDropdown(this.element);
    }
  }
  selectboxChange() {
    var value = event.target.getAttribute('data-value');
    var selectboxID = event.target.getAttribute('data-selectboxid');
    var selEl = this.element.querySelector('#' + selectboxID);
    if (selEl.nodeName == 'SELECT') {
      selEl.value = value;
      selEl.dispatchEvent(new Event('change'));
    } else {
      selEl.querySelector('[value="' + value + '"]').setAttribute('checked', 'true');
    }
    this.mainButton.querySelector('.RevolutionDropdown--Title').innerHTML = value;
    this.closeDropdown(this.element);
  }
  selectboxSubmit() {
    var value = event.target.getAttribute('data-value');
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector('.RevolutionDropdown--Title').innerHTML = value;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    var selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),
      titleElement = this.element.querySelector('.RevolutionDropdown--Title');
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute('data-value');
    }
    trapFocus(this.element);
    this.element.style.display = 'block';
  }

  toggleDropdown(event, target) {
    var isOpen = target.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    var siblings = new DomHelper().getSiblings(target.parentElement, '.RevolutionDropdown');
    siblings.forEach(function (item) {
      item.querySelector('.RevolutionDropdown--Button').setAttribute('aria-expanded', false);
      item.querySelector('.RevolutionDropdown--Content').setAttribute('aria-hidden', true);
      item.querySelector('.RevolutionDropdown--Content').style.display = 'none';
    });

    target.setAttribute('aria-expanded', true);
    target.parentElement.querySelector('.RevolutionDropdown--Content').setAttribute('aria-hidden', false);
    target.parentElement.querySelector('.RevolutionDropdown--Content').style.display = 'block';
    window.addEventListener('click', this.onClickOutsideListener);
  }

  closeDropdown(target) {
    var closestDropdown = target.closest('.RevolutionDropdown');

    if (closestDropdown === null) {
      var closestDropdown = target.querySelector("[aria-expanded='true']").parentElement;
    }

    closestDropdown.querySelector('.RevolutionDropdown--Button').setAttribute('aria-expanded', false);
    closestDropdown.querySelector('.RevolutionDropdown--Content').setAttribute('aria-hidden', true);
    setTimeout(() => {
      closestDropdown.querySelector('.RevolutionDropdown--Content').style.display = 'none';
    }, 300);

    window.removeEventListener('click', this.onClickOutsideListener);
  }
}

class Form {
  constructor() {}

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf('[');

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === '' || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {};
    var i = 0;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
            extended[prop] = Form.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}
class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      var contentToAnimate = this.element.querySelectorAll('[data-animation]');
      contentToAnimate.forEach((item, i) => {
        this.setupAnimation(item, i);
      });
    }
  }
  slideUp() {
    this.element.style.height = this.element.scrollHeight + 'px';
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    var _this = this;
    if (this.element.style.height === 'auto') {
      return;
    }

    this.element.style.height = this.element.scrollHeight + 'px';
    this.element.setAttribute('aria-hidden', false);
    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === 'height') {
        _this.element.style.height = 'auto'; // Allows the content to grow normally
        _this.element.removeEventListener('transitionend', transitionEnded);
      }
    };

    this.element.addEventListener('transitionend', transitionEnded);
  }

  elementScaleOut(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute('data-loaded')) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: 'scale(104%)', opacity: '0' },
          { transform: 'scale(100%)', opacity: '1' },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: 'forwards',
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute('data-loaded', true);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute('data-loaded')) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: 'scale(96%)', opacity: '0' },
          { transform: 'scale(100%)', opacity: '1' },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: 'forwards',
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute('data-loaded', true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute('data-loaded')) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: 'translateY(-30px)', opacity: '0' },
          { transform: 'translateY(0px)', opacity: '1' },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: 'forwards',
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute('data-loaded', true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute('data-loaded')) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: 'translateY(30px)', opacity: '0' },
          { transform: 'translateY(0px)', opacity: '1' },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: 'forwards',
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute('data-loaded', true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute('data-loaded')) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: 'translateX(30px)', opacity: '0' },
          { transform: 'translateX(0px)', opacity: '1' },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: 'forwards',
        });
        item.setAttribute('data-loaded', true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute('data-loaded')) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: 'translateX(-30px)', opacity: '0' },
          { transform: 'translateX(0px)', opacity: '1' },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: 'forwards',
        });
        item.setAttribute('data-loaded', true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute('data-loaded')) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: 'translateX(120px)', opacity: '0' },
          { transform: 'translateX(0px)', opacity: '1' },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: 'forwards',
        });
        item.setAttribute('data-loaded', true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute('data-loaded')) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: 'translateX(-120px)', opacity: '0' },
          { transform: 'translateX(0px)', opacity: '1' },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: 'forwards',
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute('data-loaded', true);
    });
  }
  setupAnimation(animatedItem, i) {
    var options = [],
      query = '';
    options['integer'] = i;
    options['type'] = animatedItem.getAttribute('data-animation');

    var _this = this;
    if (this.intersectionObserver[i]) {
      this.intersectionObserver[i].disconnect();
    }
    this.intersectionObserver[i] = new IntersectionObserver(this.reveal.bind(this, options), {
      threshold: 0.3,
    });
    if (window.theme.enableImageAnimations && window.theme.enableTextAnimations) {
      query = '.animatedContent, .animatedTextContent';
    } else if (window.theme.enableTextAnimations) {
      query = '.animatedTextContent';
    } else if (window.theme.enableImageAnimations) {
      query = '.animatedContent';
    }
    new DomHelper().nodeListToArray(animatedItem.querySelectorAll('.animatedContent, .animatedTextContent')).forEach(function (item) {
      _this.intersectionObserver[i].observe(item);
    });
  }

  reveal(a, results) {
    var _this = this;
    var integer = a['integer'];
    var toReveal = [];
    results.forEach(function (result) {
      if (result.isIntersecting || result.intersectionRatio > 0) {
        // isIntersecting does not exist on Samsung Android browser
        toReveal.push(result.target);
        _this.intersectionObserver[integer].unobserve(result.target);
      }
    });

    if (toReveal.length === 0) {
      return;
    }

    switch (a['type']) {
      case 'elementFromTop':
        this.elementFromTop(toReveal);
        break;

      case 'elementFromBottom':
        this.elementFromBottom(toReveal);
        break;

      case 'elementFromRight':
        this.elementFromRight(toReveal);
        break;

      case 'elementFromLeft':
        this.elementFromLeft(toReveal);
        break;
      case 'elementFromLeftBig':
        this.elementFromLeftBig(toReveal);
        break;
      case 'elementFromRightBig':
        this.elementFromRightBig(toReveal);
        break;
      case 'elementScaleIn':
        this.elementScaleIn(toReveal);
        break;
      case 'elementScaleOut':
        this.elementScaleOut(toReveal);
    }
  }
}
class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector('.pageLoader');
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on('click', '[data-action=add-to-cart]', this.addToCart.bind(this));
    this.delegateElement.on('click', '[data-action=hover-to-cart]', this.handleHoverATC.bind(this));
    this.delegateElement.on('submit', 'form[action="/cart/addall"]', this.addAllToCart.bind(this));
  }
  handleHoverATC() {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + '%';
    addToCartButton.setAttribute('disabled', 'disabled');
    var formElement = this.element.querySelector('#' + event.target.getAttribute('form'));
    var inputElement = formElement.querySelector('[name="id"]');
    inputElement.value = event.target.value;

    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    fetch(window.routes.localeRootUrl + '/cart/add.js', {
      body: JSON.stringify(serialized),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function (response) {
      if (response.ok) {
        addToCartButton.removeAttribute('disabled');
        _this.element.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = '';
          errorMessageElement.innerHTML = content['description'];
          addToCartButton.removeAttribute('disabled');
          addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
          setTimeout(function () {
            errorMessageElement.remove();
          }, 2500);
        });
      }
    });
  }

  addToCart() {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + '%';
    addToCartButton.setAttribute('disabled', 'disabled');
    var formElement = event.target.closest('form');
    var inputElements = formElement.querySelectorAll('[name="id"]');
    formElement.querySelector('[name="id"]').removeAttribute('disabled');
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    fetch(window.routes.localeRootUrl + '/cart/add.js', {
      body: JSON.stringify(serialized),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function (response) {
      if (response.ok) {
        addToCartButton.removeAttribute('disabled');
        _this.element.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = '';
          errorMessageElement.innerHTML = content['description'];
          addToCartButton.removeAttribute('disabled');
          addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
          setTimeout(function () {
            errorMessageElement.remove();
          }, 2500);
        });
      }
    });
  }

  addAllToCart(event) {
    var _this = this;
    event.preventDefault(); // Prevent form to be submitted
    this.element = event.target;
    var addToCartButton = this.element.querySelector('.BundleAdd');

    // First, we switch the status of the button
    addToCartButton.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    // Then we add the product in Ajax
    var formElement = event.target;
    var formHelper = new Form();
    const formElementSerialized = formHelper.serialize(formElement);
    const items = [];
    const keys = Object.keys(formElementSerialized);

    var quant = 1;
    keys.forEach((key) => {
      if (key != 'event_id') {
        let productID = formElement.querySelector('[name="' + key + '"]').getAttribute('data-id');

        if (productID) {
          quant = formElement.querySelector('#quantity--id_' + productID);
          if (quant) {
            quant = quant.getAttribute('value');
          }
        }

        items.push({
          id: formElementSerialized[key],
          quantity: quant,
        });
      }
    });
    fetch('/cart/add.js', {
      body: JSON.stringify({
        items: items,
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
      },
    }).then(function (response) {
      if (response.ok) {
        addToCartButton.removeAttribute('disabled');
        // We simply trigger an event so the mini-cart can re-render
        _this.element.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: _this.currentVariant,
              quantity: keys.length,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error u-p4';
          errorMessageElement.innerHTML = content['description'];
          addToCartButton.removeAttribute('disabled');
          addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
          setTimeout(function () {
            errorMessageElement.remove();
          }, 2500);
        });
      }
    });

    event.preventDefault();
  }
}

class Dropdown {
  constructor(element) {
    this.element = element;
    this.domDelegate = new Delegate(this.element);
    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on('click', '[data-action=toggle-dropdown]', this.toggleDropdown.bind(this));
  }
  openDropdown(elem) {
    const dropdownButton = elem.querySelector('.DropdownButton'),
      dropdownContent = elem.querySelector('.DropdownContent');

    var allDropdowns = new DomHelper().getSiblings(elem.closest('.parentSibling'), '.parentSibling');
    //      var allDropdowns = this.element.querySelectorAll('.DropdownContent[aria-hidden="false"]');
    dropdownButton.setAttribute('aria-expanded', true);
    new RevolutionAnimation(dropdownContent, 'true').slideDown();
    allDropdowns.forEach((item, i) => {
      this.closeDropdown(item);
    });
  }

  closeDropdown(elem) {
    const dropdownButton = elem.querySelector('.DropdownButton'),
      dropdownContent = elem.querySelector('.DropdownContent');
    new RevolutionAnimation(dropdownContent, true).slideUp();
    dropdownButton.setAttribute('aria-expanded', false);
    setTimeout(function () {
      dropdownContent.setAttribute('aria-hidden', true);
    }, 250);
  }
  toggleDropdown(event, target) {
    event.preventDefault(event);
    const mainDropdown = target.closest('.Dropdown');
    var isOpen = target.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      this.closeDropdown(mainDropdown, target);
    } else {
      this.openDropdown(mainDropdown, target);
    }
  }
}

(function (funcName, baseObj) {
  'use strict';
  // The public function name defaults to window.docReady
  // but you can modify the last line of this function to pass in a different object or method name
  // if you want to put them in a different namespace and those will be used instead of
  // window.docReady(...)
  funcName = funcName || 'docReady';
  baseObj = baseObj || window;
  var readyList = [];
  var readyFired = false;
  var readyEventHandlersInstalled = false;

  // call this when the document is ready
  // this function protects itself against being called more than once
  function ready() {
    if (!readyFired) {
      // this must be set to true before we start calling callbacks
      readyFired = true;
      for (var i = 0; i < readyList.length; i++) {
        // if a callback here happens to add new ready handlers,
        // the docReady() function will see that it already fired
        // and will schedule the callback to run right after
        // this event loop finishes so all handlers will still execute
        // in order and no new ones will be added to the readyList
        // while we are processing the list
        readyList[i].fn.call(window, readyList[i].ctx);
      }
      // allow any closures held by these functions to free
      readyList = [];
    }
  }

  function readyStateChange() {
    if (document.readyState === 'complete') {
      ready();
    }
  }

  // This is the one public interface
  // docReady(fn, context);
  // the context argument is optional - if present, it will be passed
  // as an argument to the callback
  baseObj[funcName] = function (callback, context) {
    if (typeof callback !== 'function') {
      throw new TypeError('callback for docReady(fn) must be a function');
    }
    // if ready has already fired, then just schedule the callback
    // to fire asynchronously, but right away
    if (readyFired) {
      setTimeout(function () {
        callback(context);
      }, 1);
      return;
    } else {
      // add the function and context to the list
      readyList.push({ fn: callback, ctx: context });
    }
    // if document already ready to go, schedule the ready function to run
    // IE only safe when readyState is "complete", others safe when readyState is "interactive"
    if (document.readyState === 'complete' || (!document.attachEvent && document.readyState === 'interactive')) {
      setTimeout(ready, 1);
    } else if (!readyEventHandlersInstalled) {
      // otherwise if we don't have event handlers installed, install them
      if (document.addEventListener) {
        // first choice is DOMContentLoaded event
        document.addEventListener('load', ready, false);
        // backup is window load event
        window.addEventListener('DOMContentLoaded', ready, false);
      } else {
        // must be IE
        document.attachEvent('onreadystatechange', readyStateChange);
        window.attachEvent('onload', ready);
      }
      readyEventHandlersInstalled = true;
    }
  };
})('docReady', window);
// modify this previous line to pass in your own method name
// and object for the method to be attached to

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add('user-is-tabbing');

    window.removeEventListener('keydown', handleFirstTab);
    window.addEventListener('mousedown', handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove('user-is-tabbing');

  window.removeEventListener('mousedown', handleMouseDownOnce);
  window.addEventListener('keydown', handleFirstTab);
}

window.addEventListener('keydown', handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}
class DomHelper {
  constructor() {}
  getSiblings(element, filter) {
    var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var siblings = [];
    var currentElement = element;

    // Do the previous first
    while ((currentElement = currentElement.previousElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    if (includeSelf) {
      siblings.push(element);
    }

    // Then the next side
    currentElement = element;

    while ((currentElement = currentElement.nextElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    return siblings;
  }

  nodeListToArray(nodeList, filter) {
    var items = [];

    for (var i = 0; i !== nodeList.length; ++i) {
      if (!filter || nodeList[i].matches(filter)) {
        items.push(nodeList[i]);
      }
    }

    return items;
  }
  outerWidthWithMargin(element) {
    var width = element.offsetWidth,
      style = getComputedStyle(element);

    width += parseInt(style.marginLeft) + parseInt(style.marginRight);

    return width;
  }
  outerHeightWithMargin(element) {
    var height = element.offsetHeight,
      style = getComputedStyle(element);

    height += parseInt(style.marginTop) + parseInt(style.marginBottom);

    return height;
  }
}

class Responsive {
  constructor() {
    var _this = this;

    this.currentBreakpoint = this.getCurrentBreakpoint();

    window.addEventListener('resize', function () {
      var newBreakpoint = _this.getCurrentBreakpoint();

      if (_this.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(
        new CustomEvent('breakpoint:changed', {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint,
          },
        })
      );

      _this.currentBreakpoint = newBreakpoint;
    });
  }

  matchesBreakpoint(breakpoint) {
    switch (breakpoint) {
      case 'phone':
        return window.matchMedia('screen and (max-width: 640px)').matches;

      case 'tablet':
        return window.matchMedia('screen and (min-width: 641px) and (max-width: 1024px)').matches;

      case 'tablet-and-up':
        return window.matchMedia('screen and (min-width: 1025px)').matches;

      case 'pocket':
        return window.matchMedia('screen and (max-width: 1024px)').matches;

      case 'lap-and-up':
        return window.matchMedia('screen and (min-width: 1024px)').matches;

      case 'desk':
        return window.matchMedia('screen and (min-width: 1280px)').matches;

      case 'widescreen':
        return window.matchMedia('screen and (min-width: 1600px)').matches;
    }
  }
  getCurrentBreakpoint() {
    if (window.matchMedia('screen and (max-width: 640px)').matches) {
      return 'phone';
    }

    if (window.matchMedia('screen and (min-width: 641px) and (max-width: 1024px)').matches) {
      return 'tablet';
    }

    if (window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches) {
      return 'lap';
    }

    if (window.matchMedia('screen and (min-width: 1280px)').matches) {
      return 'desk';
    }
  }
}
class Image {
  constructor() {}

  getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return src.replace(/http(s)?:/, '');
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
    } else {
      return null;
    }
  }
  getSupportedSizes(image, desiredSizes) {
    var supportedSizes = [],
      imageWidth = image['width'];

    desiredSizes.forEach(function (width) {
      if (imageWidth >= width) {
        supportedSizes.push(width);
      }
    });

    return supportedSizes;
  }
}

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(element.getAttribute('data-swiper-settings'));

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(additionalSwiper.getAttribute('data-swiper-thumb-settings'));
    }
    this.options = options;
    this.build();
  }

  destroy() {
    this.swiperElement.destroy();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this;

    var configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs['swiper'] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on('slideChange', function () {
      _this.element.dispatchEvent(
        new CustomEvent('slideChangeD', {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.$el[0],
          },
        })
      );
    });
  }
}

class Drawer {
  constructor(element) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector('.pageOverlay');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    this.onOpen = options['onOpen'] || function () {};
    this.onClose = options['onClose'] || function () {};
    this.isOpen = false;

    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on('click', '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]', this.openDrawer.bind(this));
    this.delegateBody.on('click', '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]', this.closeDrawer.bind(this));
    this.delegateBody.on('click', '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]', this.toggleDrawer.bind(this));
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    window.addEventListener('resize', this.calculateMaxHeightListener);
  }

  maxHeight() {
    this.element.style.height = window.innerHeight + 'px';
    if (this.element.getAttribute('id') == 'cart' || this.element.getAttribute('id') == 'sidebarFavorites') {
      var footer = this.element.querySelector('.CartDrawer--Footer');
      var footerHeight = 0;
      if (footer !== null) {
        footerHeight = footer.offsetHeight;
      }

      var header = this.element.querySelector('.CartHeader').offsetHeight;
      var cartItem = this.element.querySelector('.cart-item');
      if (cartItem !== null) {
        var itemHeight = cartItem.offsetHeight;
      }

      var itemWrapper = this.element.querySelector('.CartItems--Wrapper');

      if (itemWrapper !== null) {
        itemWrapper.style.height = window.innerHeight - footerHeight - header + 'px';
      }
    }
  }

  toggleDrawer() {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer() {
    this.element.dispatchEvent(new CustomEvent('closeSearch', { bubbles: true }));
    setTimeout(() => {
      if (this.element.getAttribute('id') == 'cart') {
        var count = window.theme.cartCount;

        if (count > 0) {
          this.element.querySelector('.CartDrawer--Expendable').setAttribute('aria-expanded', true);
        }
      }
    }, 200);

    if (this.isOpen) {
      return;
    }

    var drawers = document.querySelectorAll('#favoritesDrawer[aria-expanded="true"]');
    drawers.forEach((item, i) => {
      item.setAttribute('aria-expanded', 'false');
      removeTrapFocus(item);
      this.closeAnimation(item);
      item.isOpen = false;
    });

    this.element.dispatchEvent(new CustomEvent('closeMenu', { bubbles: true }));
    this.maxHeight();
    if (this.element.getAttribute('id') == 'sidebarDrawer') {
      document.querySelector('.SidebarDrawer__Close').style.display = 'block';
      this.element.dispatchEvent(
        new CustomEvent('sidebar-drawer:open', {
          bubbles: true,
        })
      );
    } else if (this.element.getAttribute('id') == 'favoritesDrawer') {
      this.element.dispatchEvent(
        new CustomEvent('favorite-product:open', {
          bubbles: true,
        })
      );
    }
    this.element.setAttribute('aria-expanded', 'true');
    this.pageOverlayElement.classList.add('is-visible');
    this.pageOverlayElement.addEventListener('click', this._closeListener);
    var focus = this.element.querySelector('[data-scrollable]');
    bodyScrollLock.disableBodyScroll(focus);
    document.body.classList.add('scrollLock');
    this.isOpen = true;
    trapFocus(this.element);
    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }

    if (this.element.getAttribute('id') == 'sidebarDrawer') {
    }
    document.body.classList.remove('scrollLock');

    bodyScrollLock.clearAllBodyScrollLocks();
    if (this.element.getAttribute('id') == 'cart') {
      var options = JSON.parse(this.element.getAttribute('data-settings'));
      if (options['showRecommendations']) {
        this.element.querySelector('.CartDrawer--Expendable').setAttribute('aria-expanded', false);
        setTimeout(() => {
          this.element.querySelector('.CustomCart__Recommendations').innerHTML = '';
        }, 800);
      }
    }
    this.element.setAttribute('aria-expanded', 'false');

    this.pageOverlayElement.classList.remove('is-visible');
    this.pageOverlayElement.removeEventListener('click', this._closeListener);
    removeTrapFocus(this.element);
    this.closeAnimation(this.element);
    this.isOpen = false;
    this.onClose();
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define('product-form', ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.counter = 0;
    this.counter = document.querySelector('#counter');
    this.options = JSON.parse(this.element.getAttribute('data-settings'));
    const countInterval = setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const countDate = new Date('March 3, 2030,' + this.options['countdownTime']);
    const nOfDays = this.options['countdownDays'];
    const difference = countDate - dateNow;
    var textDays = 0;
    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;
    const todaysDay = dateNow.getDay();

    const textHours = Math.floor((difference % days) / hours);
    const textMinutes = Math.floor((difference % hours) / minutes);
    const textSeconds = Math.floor((difference % minutes) / seconds);

    if (todaysDay == 1) {
      textDays = nOfDays;
    } else if (todaysDay == 0) {
      textDays = 0;
    } else {
      textDays = nOfDays - todaysDay;
      if (textDays < 0) {
        const mDays = todaysDay % nOfDays;
        textDays = nOfDays - mDays;
      }
    }

    if (this.options['excludeWeekends'] && todaysDay == 5) {
      textDays = textDays + 2;
    } else if (this.options['excludeWeekends'] && todaysDay == 6) {
      textDays = textDays + 1;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;
    document.getElementById('counter').innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
  }
}
customElements.define('countdown-element', Countdown);

class FavoritesDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.element.getAttribute('data-settings'));
    this.loader = this.element.querySelector('.loader');
    this.cartCount = document.querySelector('.FavoritesCount');
    this.toggleFavorites();
    this.bindEvents();
  }
  unbindEvents() {
    document.removeEventListener('favorite-product:open', this.onFavoritesOpenListener);

    document.removeEventListener('click', this._addToFavoritesL);
  }
  bindEvents() {
    if (!document.body.classList.contains('listener')) {
      this.onFavoritesOpenListener = this.onFavoritesOpen.bind(this);
      this._addToFavoritesL = this.addToFavorites.bind(this);
      this.delegateBody.on('click', '[data-action="toggle-favorites"]', this._addToFavoritesL);
      document.body.classList.add('listener');
      document.addEventListener('favorite-product:open', this.onFavoritesOpenListener);
    }
  }

  onFavoritesOpen() {
    var _this = this;
    this.rerenderFavorites().then(function () {
      new AddToCart(_this.element);
    });
    this.sidebarDrawer.isOpen = true;
  }

  maxHeight() {
    var footer = this.element.querySelector('.CartDrawer--Footer').offsetHeight;
    var header = this.element.querySelector('.CartHeader').offsetHeight;
    this.element.querySelector('.CartItems--Wrapper').style.height = window.innerHeight - footer + 'px';
  }

  getSearchQueryStrings() {
    var items = JSON.parse(localStorage.getItem('productFavorites') || '[]');
    // If we are on a product template, we make sure to remove the main product from the related product
    const bucketSize = 10.0;
    const idBuckets = [];
    items.forEach((id, index) => {
      const key = Math.floor(index / bucketSize);
      if (!idBuckets[key]) {
        idBuckets[key] = [];
      }
      idBuckets[key].push(id);
    });
    return idBuckets.reduce((acc, vall) => {
      const string = vall
        .map(function (id) {
          return 'id:' + id;
        })
        .join(' OR ');

      acc.push(string);
      return acc;
    }, []);
  }

  rerenderFavorites(event, elementToAnimate) {
    this.loader.classList.add('is-visible');
    var _this32 = this;
    var queryStrings = this.getSearchQueryStrings();
    const promises = [];
    if (queryStrings.length == 0) {
      this.loader.classList.remove('is-visible');
      fetch('/?section_id=favorites-drawer').then(function (content) {
        content.text().then(function (html) {
          _this32.replaceContentFav(html);
          _this32.loader.classList.remove('is-visible');
          _this32.loadRecommendations();
        });
      });

      //  return;
    }
    queryStrings.forEach((string) => {
      promises.push(
        fetch('/search?view=favorites&type=product&q=' + string, {
          credentials: 'same-origin',
          method: 'GET',
        })
      );
    });
    promises.reduce(async (acc, val, index) => {
      const content = await val.then((response) => response.text());
      const container = this.element;
      if (!container.length) {
        _this32.replaceContentFav(content);
        _this32.loader.classList.remove('is-visible');
        _this32.maxHeight();
      } else {
        this.loader.classList.remove('is-visible');
      }
    }, Promise.resolve());

    return Promise.resolve();
  }

  replaceContentFav(html) {
    var tempElement = document.createElement('div');
    tempElement.innerHTML = html;
    var number = tempElement.querySelector('.countFav').getAttribute('data-count');
    var cartNodeParent = this.element.querySelector('.CartDrawer');
    cartNodeParent.replaceChild(tempElement.querySelector('#cartData'), this.element.querySelector('#cartData'));
    this.toggleFavorites();
    this.loader.classList.remove('is-visible');
    return true;
  }

  toggleFavorites() {
    var items = JSON.parse(localStorage.getItem('productFavorites') || '[]');
    var favorites = document.querySelectorAll('.ProductCard--Favorites');
    favorites.forEach(function (item) {
      var state = item.getAttribute('state');
      var myID = item.getAttribute('data-id');

      if (state == 'not-active' && items.includes(myID)) {
        item.querySelector('.brokenHearth').style.display = 'block';
        item.querySelector('.emptyHearth').style.display = 'none';
        item.setAttribute('state', 'active');
      } else if (!items.includes(myID)) {
        item.querySelector('.brokenHearth').style.display = 'none';
        item.querySelector('.emptyHearth').style.display = 'block';
        item.setAttribute('state', 'not-active');
      }
    });
  }

  removeFromFavorites(productId) {
    var items = JSON.parse(localStorage.getItem('productFavorites') || '[]');
    items = items.filter((c) => c != productId);

    try {
      localStorage.setItem('productFavorites', JSON.stringify(items.slice(0, 50)));
    } catch (error) {
      console.log(error);
    }
    var _this = this;
    this.toggleFavorites();
    if (this.sidebarDrawer.isOpen == true) {
      this.rerenderFavorites().then(function () {
        new AddToCart(_this.element);
      });
    }
  }

  loadRecommendations() {
    var _this = this;
    console.log(this.options['productID']);
    if (this.options['productID']) {
      var url = '/recommendations/products?section_id=cart-recommendations&product_id=' + this.options['productId'] + '&limit=6';
      var _this = this;
      return fetch(url).then(function (response) {
        return response.text().then(function (content) {
          var container = document.createElement('div');
          container.innerHTML = content;

          var x = _this.element.querySelector('.swiperFavorites .swiper');

          const swiper = new Swiper(x, {
            // Default parameters
            slidesPerView: 2,
            spaceBetween: 16,
            navigation: false,
            loop: false,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,

            breakpoints: {
              1024: {
                slidesPerView: 1.95,
                spaceBetween: 16,
                navigation: {
                  nextEl: '.favNext',
                  prevEl: '.favPrev',
                },
              },
            },
          });
          new AddToCart(x);
          _this.toggleFavorites();
        });
      });
    } else {
      var x = _this.element.querySelector('.swiperFavorites .swiper');

      const swiper = new Swiper(x, {
        // Default parameters
        slidesPerView: 2,
        spaceBetween: 16,
        navigation: false,
        loop: false,
        slidesOffsetAfter: 0,
        slidesOffsetBefore: 0,

        breakpoints: {
          1024: {
            slidesPerView: 1.95,
            spaceBetween: 16,
            navigation: {
              nextEl: '.favNext',
              prevEl: '.favPrev',
            },
          },
        },
      });
      new AddToCart(x);
      _this.toggleFavorites();
    }
  }

  addToFavorites(event) {
    event.preventDefault();
    var _this = this;
    var items = JSON.parse(localStorage.getItem('productFavorites') || '[]');
    var productId = event.target.getAttribute('data-id');

    // We check if the current product already exists, and if it does not, we add it at the start
    if (!items.includes(productId) && productId != '') {
      items.unshift(productId);
    } else {
      this.removeFromFavorites(productId, false);
      //   this._favoritesNumber();
      return;
    }
    // Then, we save the current product into the local storage, by keeping only the 50 most recent
    try {
      localStorage.setItem('productFavorites', JSON.stringify(items.slice(0, 50)));
      //    this._favoritesNumber();
      this.toggleFavorites();
      if (this.sidebarDrawer.isOpen == true) {
        this.rerenderFavorites().then(function () {
          new AddToCart(_this.element);
        });
      }
    } catch (error) {
      // Do nothing, this may happen in Safari in incognito mode
    }
  }
}
customElements.define('favorites-drawer', FavoritesDrawer);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.loader = this.element.querySelector('.itemLoader');
    this.cartCount = document.querySelector('.CartCount');
    this.options = JSON.parse(this.element.getAttribute('data-settings'));
    this.pageLoader = document.body.querySelector('.pageLoader');
    if (window.location.href.indexOf('?sideDrawer=true') > -1) {
      this.sidebarDrawer.openDrawer();
    }
    if (this.options['showRecommendations']) {
      this.loadRecommendations();
      this.breakpoint = new Responsive().getCurrentBreakpoint();
      if (this.breakpoint == 'phone' || this.breakpoint == 'tablet') {
        this.loadRecommendationsMobile();
      }
    }

    this.bindEvents();
  }
  onUnload() {
    this.delegateElement.off();
    document.removeEventListener('product:added', this.onProductAddedListener);
  }
  bindEvents() {
    if (window.theme.listener == 'false') {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener('product:added', this.onProductAddedListener);
      this.delegateElement.on(
        'click',
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on('change', '.QuantitySelector__CurrentQuantity', this.updateItemQuantity.bind(this));

      this.delegateElement.on('click', "[data-action='clear-cart']", this.clearCart.bind(this));

      window.theme.listener = 'true';
    }
  }
  clearCart() {
    const _this = this;
    fetch(window.routes.localeRootUrl + '/cart/clear.js', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function (content) {
      _this.renderCart();
    });
  }
  updateItemQuantity(event, target) {
    event.preventDefault();

    target.closest('.cart-item').querySelector('.itemLoader').classList.add('is-visible');
    var _this = this;

    var quantity = null,
      elementToAnimate = null;
    if (target.tagName === 'INPUT') {
      quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
    } else {
      quantity = parseInt(target.getAttribute('data-quantity'));
    }

    fetch(window.routes.localeRootUrl + '/cart/change.js', {
      body: JSON.stringify({
        id: target.getAttribute('data-line-id'),
        quantity: quantity,
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function (content) {
      _this.renderCart(target.getAttribute('data-id'));
    });
  }

  onProductAdded() {
    var _this = this;

    this.renderCart().then(function () {
      _this.sidebarDrawer.openDrawer();
    });
  }

  renderCart(lineNumber) {
    this.pageLoader.style.width = 100 + '%';

    var _this = this;
    return fetch(window.routes.localeRootUrl + '/?section_id=cart-drawer', {
      credentials: 'same-origin',
      method: 'GET',
    }).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(html, lineNumber);
      });
    });
  }

  replaceContent(html, lineNumber) {
    var _this = this;
    this.pageLoader.style.left = 'unset';
    this.pageLoader.style.right = 0 + 'px';
    this.pageLoader.style.width = 0 + '%';
    setTimeout(() => {
      this.pageLoader.style.left = 0 + 'px';
      this.pageLoader.style.right = 'unset';
    }, 550);
    var tempElement = document.createElement('div');
    tempElement.innerHTML = html;
    this.tempOptions = JSON.parse(tempElement.querySelector('#cart').getAttribute('data-settings'));

    var number = this.tempOptions['itemCount'];
    this.cartCount.innerHTML = '(' + number + ')';
    window.theme.cartCount = parseInt(number);
    if (lineNumber) {
      const cartNodeParent = this.element.querySelector('#' + lineNumber);
      const itemToReplaceWith = tempElement.querySelector('#' + lineNumber + ' .cartItem--Informations');
      if (cartNodeParent.querySelector('.itemLoader')) {
        cartNodeParent.querySelector('.itemLoader').classList.remove('is-visible');
      }
      if (itemToReplaceWith) {
        cartNodeParent.replaceChild(itemToReplaceWith, cartNodeParent.querySelector('.cartItem--Informations'));
      } else {
        cartNodeParent.classList.add('removing');
        setTimeout(() => {
          cartNodeParent.remove();
        }, 300);
      }
      if (number > 0) {
        const checkoutButtonParent = this.element.querySelector('.CartDrawer--Footer');
        const checkoutButtonToReplace = tempElement.querySelector('.cartCheckout--Button');
        checkoutButtonParent.replaceChild(checkoutButtonToReplace, checkoutButtonParent.querySelector('.cartCheckout--Button'));
      } else {
        this.element.querySelector('.CartDrawer--Expendable').setAttribute('aria-expanded', false);
        this.element.querySelector('.CartDrawer--Footer').classList.add('removing');

        const mainPartParent = this.element.querySelector('.CartDrawer');

        mainPartParent.innerHTML = tempElement.querySelector('.CartDrawer').innerHTML;
        if (window.theme.enableImageAnimations) {
          const mainPartchildren = mainPartParent.querySelector('.CartItems--EmptyWrapper');
          mainPartchildren.animate(
            [
              // keyframes
              { opacity: '0' },
              { opacity: '1' },
            ],
            {
              // timing options
              duration: 500,
              fill: 'forwards',
            }
          );
        }
      }
      if (this.element.querySelector('.itemLoader')) {
        setTimeout(() => {
          this.element.querySelector('.itemLoader').classList.remove('is-visible');
        }, 250);
      }
    } else {
      const cartNodeParent = this.element.querySelector('.CartDrawer').parentNode;
      const currentScrollPosition = this.element.querySelector('#main-cart-items').scrollTop;

      cartNodeParent.replaceChild(tempElement.querySelector('.CartDrawer'), this.element.querySelector('.CartDrawer'));
      this.element.querySelector('#main-cart-items').scrollTop = currentScrollPosition;
    }
    setTimeout(() => {
      var count = window.theme.cartCount;
      if (this.options['showRecommendations']) {
        if (this.breakpoint == 'phone') {
          this.loadRecommendationsMobile();
        } else {
          this.loadRecommendations();
        }
      }
      var focus = _this.element.querySelector('[data-scrollable]');
      bodyScrollLock.disableBodyScroll(focus);
      _this.sidebarDrawer.maxHeight();
    }, 200);
  }

  loadRecommendations() {
    var _this = this;
    if (this.options['productId'] == '') {
      var url = '?section_id=cart-recommendations';
    } else {
      var url =
        window.routes.localeRootUrl +
        '/recommendations/products?section_id=cart-recommendations&product_id=' +
        this.options['productId'] +
        '&limit=10';
    }
    var _this = this;
    return fetch(url).then(function (response) {
      return response.text().then(function (content) {
        var container = document.createElement('div');
        container.innerHTML = content;
        var z = container.querySelector('.cartUpsell').innerHTML;
        if (window.theme.cartCount == 0) {
          var x = _this.element.querySelector('.emptyRecommendations');
          x.innerHTML = z;
          const swiper = new Swiper('.swiperUpsell', {
            //    Default parameters
            slidesPerView: 2,
            spaceBetween: 16,
            navigation: true,
            loop: false,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
            navigation: {
              nextEl: '.swiperNextCart',
              prevEl: '.swiperPrevCart',
            },
            breakpoints: {
              1024: {
                slidesPerView: 1.95,
                slidesOffsetAfter: 0,
                slidesOffsetBefore: 0,
                spaceBetween: 16,
              },
            },
          });
        } else {
          var x = _this.element.querySelector('.withItemRecommendations');
          x.innerHTML = z;
          const swiper = new Swiper('.swiperUpsell', {
            //  Default parameters
            slidesPerView: 2,
            spaceBetween: 16,
            navigation: {
              nextEl: '.swiperNextCart',
              prevEl: '.swiperPrevCart',
            },
            loop: false,
            breakpoints: {
              1024: {
                slidesPerView: 2,
                spaceBetween: 32,
              },
            },
          });
        }

        new AddToCart(x);
      });
    });
  }

  loadRecommendationsMobile() {
    var _this = this;
    if (this.options['productId'] == '') {
      var url = '?section_id=cart-recommendations-mobile';
    } else {
      var url = '/recommendations/products?section_id=cart-recommendations-mobile&product_id=' + this.options['productId'] + '&limit=10';
    }
    return fetch(url).then(function (response) {
      return response.text().then(function (content) {
        var container = document.createElement('div');
        container.innerHTML = content;
        var z = container.querySelector('.cartUpsell').innerHTML;

        var ix = _this.element.querySelector('.CartMobileRecommendations');

        if (ix !== null) {
          ix.innerHTML = z;
          new AddToCart(ix);
          if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
            new RevolutionAnimation(_this.element);
          }

          if (window.theme.cartCount == 0) {
            var x = _this.element.querySelector('.emptyRecommendations');
            x.innerHTML = z;
            const swi = x.querySelector('.cart-upsell');
            const swiper = new Swiper(swi, {
              //    Default parameters
              slidesPerView: 2,
              spaceBetween: 16,
              navigation: true,
              loop: false,
              slidesOffsetAfter: 0,
              slidesOffsetBefore: 0,
              navigation: {
                nextEl: '.swiperNextCart',
                prevEl: '.swiperPrevCart',
              },
              breakpoints: {
                1024: {
                  slidesPerView: 1.95,
                  slidesOffsetAfter: 0,
                  slidesOffsetBefore: 0,
                  spaceBetween: 16,
                },
              },
            });
          }
        }
      });
    });
  }
}
customElements.define('cart-drawer', CartDrawer);

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector('.swiper');
    this.carousel = new RevolutionSwiper(this.carouselElement);
    this.bindEvents();
    if (window.theme.enableAnimations) {
      this.timeline = new TimelineLite({ delay: 0.4 });
    }
    new AddToCart(this.element);
  }

  bindEvents() {
    this.isPageLoaded = document.readyState === 'complete' || document.readyState === 'loaded' || document.readyState === 'interactive';
    if (!this.isPageLoaded) {
      window.addEventListener('load', this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }
  }

  onPageLoaded() {
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define('featured-collection', FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector('.swiper');
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define('slider-text', SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.element = this;
    this.pageOverlayElement = document.querySelector('.pageOverlay');
    this.carouselElement = this.element.querySelector('[data-swiper-settings]');
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
    this.delegateElement = new Delegate(this.element);
    this.onPageLoaded();
    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }
  }

  onPageLoaded() {
    if (this.options['numberOfSlides'] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.changeImageQuality();
    } else {
      this.changeImageQuality(true);
    }
    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.element.removeEventListener('swiper:images-ready', this.onImagesReady);
    this.onImagesReady = this.changeImageQuality.bind(this);
    this.element.addEventListener('swiper:slide-changed', this.onImagesReady);
    this.element.addEventListener('swiper:images-ready', this.onImagesReady);
  }
  changeImageQuality(singleItem) {
    var breakpoint = new Responsive().getCurrentBreakpoint();

    if (singleItem == true) {
      var imageContainers = this.element.querySelectorAll('.Banner__ImageContainer--Swap');
    } else {
      var currentIndex = this.carousel.swiperElement.activeIndex;
      var domHelper = new DomHelper();
      var cellElement = this.carousel.swiperElement.slides[currentIndex];
      var imageContainers = domHelper.nodeListToArray(cellElement.querySelectorAll('.Banner__ImageContainer--Swap'));
    }
    if (imageContainers.length === 0) {
      return;
    }
    var imageToReveal = null;

    if (breakpoint === 'pocket' || breakpoint === 'phone' || breakpoint === 'tablet') {
      imageToReveal = imageContainers[0].querySelector('.Banner__Image');
    } else {
      imageToReveal = imageContainers[1].querySelector('.Banner__Image');
    }
    if (imageToReveal) {
      const replaceUrl = imageToReveal.getAttribute('data-src').replace('{width}x', '1500x');

      imageToReveal.src = replaceUrl;
    }
  }
}
customElements.define('banner-hero', Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute('data-settings'));
    this.carousel = this.element.querySelectorAll('.MenuSlideshow');
    this.pageOverlayElement = document.querySelector('.pageOverlay');
    var selectBoxes = this.element.querySelectorAll('.RevolutionDropdown');
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (this.options.sticky) {
      this.toggleSticky();
    }
    this.bindEvents();
    document.documentElement.style.setProperty('--header-height', this.element.clientHeight + 'px');
    this.menuOverlapHandler();
  }

  menuOverlapHandler() {
    var currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    var menuItems = this.element.querySelector('.Header--MenuItems'),
      overlapping = false,
      menuWrapper = this.element.querySelector('.HeaderWrapper'),
      allHeights = [],
      _this = this;
    if (menuItems) {
      var desiredHeight = _this.element.querySelectorAll('.mainLinks');
      desiredHeight.forEach((item, i) => {
        allHeights.push(item.offsetHeight);
      });
      var maxHeight = Math.max.apply(null, allHeights);
      var minHeight = Math.min.apply(null, allHeights);
      if (maxHeight > minHeight) {
        overlapping = true;
        if (window.theme.menuBreakpoint == 0 || window.theme.menuBreakpoint == undefined) {
          window.theme.menuBreakpoint = currentClientWidth;
        }
      }
    }
    if (currentClientWidth > window.theme.menuBreakpoint) {
      menuItems.classList.remove('mt-m');
      menuWrapper.querySelector('.mainMenuItems').prepend(menuItems);
      window.theme.menuBreakpoint = 0;
    } else if (overlapping) {
      menuItems.classList.add('mt-m');
      menuItems.closest('.header').appendChild(menuItems);
    }

    document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
  }

  toggleSticky() {
    this.element.parentElement.classList.add('Header--Sticky');
    this.element.parentElement.classList.remove('Header--Transparent');
  }

  bindEvents() {
    this.toggleColorListener = this.toggleColor.bind(this);
    this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
    this.closeListener = this.closeMenu.bind(this);
    window.addEventListener('scroll', this.toggleColorListener);

    this.delegateElement.on('click', '.headerLink, [aria-hasmenu][aria-expanded="false"]', this.openMenu.bind(this), true);
    this.delegateElement.on('click', '.headerLink, [aria-hasmenu][aria-expanded="true"]', this.closeMenu.bind(this), true);

    window.addEventListener('resize', this.menuOverlapHandlerListener);
    window.addEventListener('openSearch', this.closeListener);
    window.addEventListener('closeMenu', this.closeListener);
    // this.delegateElement.on('focusin', '.mainMenu--Links, [aria-hasMenu]', this.openMenu.bind(this), true);
    //this.delegateElement.on('focusout', '.mainMenu--Links', this.closeMenu.bind(this), true);
  }

  openMenu(event, target) {
    event.preventDefault();
    if (target.getAttribute('aria-expanded') == 'true') {
      return;
    }
    this.element.dispatchEvent(new CustomEvent('closeSearch', { bubbles: true }));
    if (event.type === 'mouseenter' && target !== event.target) {
      return;
    }
    var _this = this;
    _this.pageOverlayElement.classList.add('is-visible');
    document.body.querySelector('#shopify-section-header').style.zIndex = 100;
    _this.pageOverlayElement.addEventListener('click', _this.closeListener);
    var domHelper = new DomHelper();
    _this.element.classList.remove('Header--Transparent');

    domHelper.nodeListToArray(target.parentElement.children, '[aria-hidden="true"]').forEach(function (item) {
      item.setAttribute('aria-hidden', 'false');
      item.style.display = 'flex';
    });

    target.parentElement.setAttribute('aria-expanded', 'true');
    target.setAttribute('aria-expanded', 'true');

    domHelper.getSiblings(target.parentElement, '[aria-expanded="true"]').forEach(function (item) {
      item.firstElementChild.setAttribute('aria-expanded', 'false');
      domHelper.nodeListToArray(item.children, '[aria-hidden="false"]').forEach(function (item) {
        item.setAttribute('aria-hidden', 'true');
        setTimeout(() => {
          item.style.display = 'none';
        }, 300);
      });
    });
  }

  closeMenu(event, target) {
    var myEvent = '';

    event.preventDefault();
    if (!target) {
      target = this.element.querySelector('[aria-hasmenu][aria-expanded="true"]');
    }
    if (target.getAttribute('aria-expanded') == 'false') {
      return;
    }
    if (event.toElement !== undefined) {
      myEvent = event.toElement;
    } else if (event.relatedTarget !== undefined) {
      myEvent = event.relatedTarget;
    }
    if (event.type === 'mouseleave' && target !== event.target) {
      return;
    }

    var _this = this;

    var domHelper = new DomHelper();
    if (_this.options['transparent']) {
      _this.element.classList.add('Header--Transparent');
    }

    target.setAttribute('aria-expanded', false);
    _this.pageOverlayElement.classList.remove('is-visible');
    document.body.querySelector('#shopify-section-header').style.zIndex = 11;
    _this.pageOverlayElement.removeEventListener('click', _this.closeListener);
    domHelper.nodeListToArray(target.parentElement.children, '[aria-hidden="false"]').forEach(function (item) {
      item.setAttribute('aria-hidden', 'true');
      setTimeout(() => {
        item.style.display = 'none';
      }, 300);
    });
  }

  toggleColor() {
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (this.options.transparent) {
      if (window.pageYOffset > 25 && this.options.sticky) {
        this.element.classList.remove('Header--Transparent');
      } else {
        this.element.classList.add('Header--Transparent');
      }
    }
  }
}
customElements.define('header-component', Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.SidebarMenu = new Drawer(this.element);
    this.dropdown = new Dropdown(this.element);
    this.carouselElement = this.element.querySelector('.MenuSlideshowMobile');

    this.bindEvents();
  }
  bindEvents() {
    document.addEventListener('sidebar-drawer:open', this.onDrawerListener);
    this.delegateElement.on('click', '[data-action="toggle-subdrawer"]', this.toggleNextElement.bind(this));

    this.delegateElement.on('click', '[data-action="toggle-prev-subdrawer"]', this.togglePreviusElement.bind(this));
  }

  toggleNextElement(event, target) {
    var nextEl = target.getAttribute('data-toggle-id'),
      subdrawer = this.element.querySelector('#' + nextEl);
    if (subdrawer && subdrawer.getAttribute('aria-hidden') == 'true') {
      subdrawer.setAttribute('aria-hidden', 'false');
    }
  }
  togglePreviusElement(event, target) {
    target.closest('.SidebarDrawer--Wrapper').setAttribute('aria-hidden', 'true');
  }
}
customElements.define('main-menu-dropdown', MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector('.pageTransition');

    if (!this.isPageLoaded) {
      document.addEventListener('DOMContentLoaded', this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: 'forwards',
        easing: 'ease-in-out',
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (event.defaultPrevented || event.ctrlKey || event.metaKey || !window.theme.showPageTransition || !this.pageOverlay) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(this.pageOverlay, 0.25, { autoAlpha: 0, ease: Linear.easeNone }, { autoAlpha: 1, ease: Linear.easeNone });
    }
  }
}
var trans = new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

    this.elementPosition = this.element.getAttribute('data-image-position');
    if (this.options['using_fade'] == 'fade') {
      if (this.element.closest('.swiper-slide').classList.contains('swiper-slide-active')) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.createObserver();
    }
  }

  bindEvents() {
    window.removeEventListener('slideChangeD', this.onSlideChangeListener);
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener('slideChangeD', this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== 'undefined') {
      this.videoPlayerInicialization();
    } else {
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event, target) {
    if (event.detail.element.getAttribute('id') == 'productSwiperElement') {
      if (event.detail.currentIndex == this.elementPosition) {
        if (!this.element.getAttribute('loaded')) {
          var node = document.createElement('div');
          node.appendChild(this.element.querySelector('template').content.firstElementChild.cloneNode(true));
          this.element.appendChild(node).focus();
          this.element.setAttribute('loaded', true);
          if (!this.videoPlayer) {
            this.checkLoaded();
          } else {
            this.videoPlayer.play();
          }
        } else {
          if (!this.videoPlayer) {
            this.checkLoaded();
          } else {
            this.videoPlayer.play();
          }
        }
      } else if (this.videoPlayer) {
        this.videoPlayer.pause();
      }
    }
  }

  videoPlayerInicialization() {
    var _this = this;
    if (!this.element.getAttribute('loaded')) {
      var node = document.createElement('div');
      node.appendChild(this.element.querySelector('template').content.firstElementChild.cloneNode(true));
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute('loaded', true);
    }
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;

    let img_plh = '';
    let aspect_ratio = '';
    let src = '';
    let controls = '';
    let host = 'html5';
    if (isMobile) {
      if (this.options['control_var']) {
        src = this.options['videom'];
      } else if (this.options['video_inside_media']) {
        src = this.options['videom']['sources'][1]['url'];
      } else {
        src = 'https://www.youtube.com/watch?v=' + this.options['videom']['external_id'];
        host = this.options['videom']['host'];
      }
      img_plh = this.options['plh_mob'];
      if (this.options['aspect_mob']) {
        aspect_ratio = this.options['aspect_mob'];
      } else {
        aspect_ratio = '9:16';
      }
    } else {
      if (this.options['control_var']) {
        src = this.options['videod'];
      } else if (this.options['video_inside_media']) {
        src = this.options['videod']['sources'][1]['url'];
      } else {
        src = 'https://www.youtube.com/watch?v=' + this.options['videod']['external_id'];
        host = this.options['videom']['host'];
      }
      img_plh = this.options['plh_desk'];
      if (this.options['aspect_desk']) {
        aspect_ratio = this.options['aspect_desk'];
      } else {
        aspect_ratio = '16:9';
      }
    }
    if (host == 'youtube') {
      var type = 'video/youtube';
    } else {
      var type = 'video/mp4';
    }

    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: this.options['autoplay'],
      muted: this.options['muted'],
      loop: this.options['loop'],
      controls: this.options['controls'],
      poster: img_plh,
      preload: 'metadata',
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        playToggle: true,
        captionsButton: false,
        chaptersButton: false,
        subtitlesButton: false,
        remainingTimeDisplay: false,
        pictureInPictureToggle: false,
        volumeControl: false,
        progressControl: {
          seekBar: false,
        },
        fullscreenToggle: false,
        playbackRateMenuButton: false,
      },
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    var videoplayerID = this.element.querySelector('video');

    this.videoPlayer = videojs(videoplayerID, payload);
    this.videoPlayer.on('ready', function () {
      _this.element.querySelector('.videoHolder').style.display = 'block';
    });
  }
  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), { threshold: 0.2 });

    const target = this.element;
    observer.observe(target);
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
        }
        if (this.options['autoplay'] && this.videoPlayer) {
          this.videoPlayer.play();
        }
      } else if (entry.intersectionRatio === 0 || entry.isIntersecting == false) {
        if (this.videoPlayer) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define('video-component', VideoComponent);

class Announcement extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.options = JSON.parse(this.getAttribute('data-settings'));

    if (this.element.classList.contains('FooterDeliveryBar') != true) {
      let breakpoint = new Responsive().getCurrentBreakpoint();
      if (breakpoint == 'phone' || breakpoint == 'tablet') {
        new RevolutionSwiper(this.element.querySelector('.swiper'));
      }
    }
  }
}
customElements.define('announcement-bar', Announcement);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint != 'phone' || breakpoint != 'tablet') {
      this.dropdown = new Dropdown(this.element);
    }
    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }
  }
}
customElements.define('footer-component', FooterComponent);

class DropdownSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.dropdown = new Dropdown(this.element);
  }
}
customElements.define('dropdown-section', DropdownSection);

class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }

    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector('.mainSwiper');
    this.carouselElementThumbs = this.element.querySelector('.ProductSlider--Thumbnails');
    if (new Responsive().matchesBreakpoint('pocket')) {
      this.carousel = new RevolutionSwiper(this.carouselElement, this.carouselElementThumbs);
    }

    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
    this.changeImageQuality();
    this.valuesWrap = this.element.querySelectorAll('.ProductOption--ValusWrapper');
    var localPickup = this.element.querySelector('#LocalPickup');
    if (localPickup) {
      new Drawer(this.querySelector('#LocalPickup'));
    }
    new AddToCart(this.element);
    new Dropdown(this.element.querySelector('.ProductInfo--Wrapper'));
    var selectBoxes = this.element.querySelectorAll('.RevolutionDropdown');
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }
    if (this.options['enable_zoom']) {
      new RevolutionImageZoom(this.element, this.carousel);
    }

    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on('variant:changed', this.updateImage.bind(this));
    this.domDelegate.on('click', '[data-action="openBIS"]', this.openBIS.bind(this));
  }

  openBIS() {
    event.preventDefault();
    BISPopover.show();
  }
  updateImage() {
    var imageID = event.detail.new_image;
    var selector = '#Image--' + imageID;
    var imageIndex = this.element.querySelector(selector).getAttribute('data-image-position');
    this.carousel.selectCell(parseInt(imageIndex));
  }

  changeImageQuality() {
    var imageToReveal = null;
    imageToReveal = this.element.querySelector('.ProductSliderCell:first-child img');
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal.getAttribute('data-src').replace('{width}x', '1500x');
      imageToReveal.src = replaceUrl;
    }
  }
}
customElements.define('product-component', ProductElement);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    var selectboxes = this.element.querySelectorAll('select');
    selectboxes.forEach((item, i) => {
      item.addEventListener('change', this.onVariantChange.bind(this));
    });
    this.productID = this.element.getAttribute('data-product-id');
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updatePickupAvailability();

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent('variant:changed', {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.productID}, #product-form-installment`);

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = '.priceAndSku';
        const id2 = '.ProductInfo--TitlePrice';

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.querySelector(id);
        const source = html.querySelector(id);
        const destination2 = document.querySelector(id2);
        const source2 = html.querySelector(id2);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source2 && destination2) destination2.innerHTML = source2.innerHTML;

        this.toggleAddButton();
      });
  }

  toggleAddButton() {
    const addButton = document.querySelector('.AddToCartAjax');
    const addButtonInner = addButton.querySelector('.SelfAlign');
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.9997 5.50008H13.333C13.333 3.65841 11.8413 2.16675 9.99967 2.16675C8.15801 2.16675 6.66634 3.65841 6.66634 5.50008H4.99967C4.08301 5.50008 3.33301 6.25008 3.33301 7.16675V17.1667C3.33301 18.0834 4.08301 18.8334 4.99967 18.8334H14.9997C15.9163 18.8334 16.6663 18.0834 16.6663 17.1667V7.16675C16.6663 6.25008 15.9163 5.50008 14.9997 5.50008ZM9.99967 3.83341C10.9163 3.83341 11.6663 4.58341 11.6663 5.50008H8.33301C8.33301 4.58341 9.08301 3.83341 9.99967 3.83341ZM14.9997 17.1667H4.99967V7.16675H6.66634V8.83342C6.66634 9.29175 7.04134 9.66675 7.49967 9.66675C7.95801 9.66675 8.33301 9.29175 8.33301 8.83342V7.16675H11.6663V8.83342C11.6663 9.29175 12.0413 9.66675 12.4997 9.66675C12.958 9.66675 13.333 9.29175 13.333 8.83342V7.16675H14.9997V17.1667Z" fill="#F58653"/></svg>';
    } else {
      var buySvg =
        '<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.8334 5.49992C18.8334 4.58325 18.0834 3.83325 17.1667 3.83325H3.83341C2.91675 3.83325 2.16675 4.58325 2.16675 5.49992V15.4999C2.16675 16.4166 2.91675 17.1666 3.83341 17.1666H17.1667C18.0834 17.1666 18.8334 16.4166 18.8334 15.4999V5.49992ZM17.1667 5.49992L10.5001 9.66658L3.83341 5.49992H17.1667ZM17.1667 15.4999H3.83341V7.16658L10.5001 11.3333L17.1667 7.16658V15.4999Z" fill="#F58653"/></svg>';
    }
    if (!addButton) return;

    if (this.currentVariant.available == false) {
      addButton.setAttribute('disabled', 'disabled');
      addButton.classList.add('ProductCard--Sold__Out');
      addButtonInner.innerHTML = buySvg + window.variantStrings.soldOut;
    } else {
      addButton.removeAttribute('disabled');
      addButton.classList.remove('ProductCard--Sold__Out');
      if (window.variantInfo.show_price) {
        var priceElement = "<span class='ml-s'>" + Shopify.formatMoney(this.currentVariant.price, window.theme.moneyFormat);
        +'</span>';
      } else {
        var priceElement = '';
      }

      addButtonInner.innerHTML = buySvg + window.variantStrings.addToCart + priceElement;
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

class Login extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.recoveryForm = this.element.querySelector('#ForgotPass');
    this.loginForm = this.element.querySelector('#logIn');
    //gsap.from("#logIn", { duration: 0.7, x: 300 });
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="toggle-recovery"]', this.openRecover.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-login"]', this.openLogin.bind(this));
    this.delegateElement.on('click', '[data-action="create-account"]', this.createAccount.bind(this));
  }
  openRecover() {
    this.recoveryForm.classList.remove('hidden');
    this.loginForm.classList.add('hidden');
    //gsap.from("#ForgotPass", { duration: 0.7, x: -200 });
  }
  openLogin() {
    this.recoveryForm.classList.add('hidden');
    this.loginForm.classList.remove('hidden');
    //gsap.from("#logIn", { duration: 0.7, x: 200 });
  }
  createAccount() {
    //gsap.from("#register", { duration: 1.5, x: 0, opacity: 0, scale: 0.5 });
  }
}
customElements.define('customer-login', Login);

class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    this.blogWrapper = this.element.querySelector('#BlogArticleWrapper');
    this.blogElement = this.element.querySelectorAll('.BlogArticle');
    this.options = JSON.parse(this.element.getAttribute('data-settings'));
    if (this.options.layout == 'masonary') {
      this.delegateElement.on('load', this.setupGetInspredGrid.bind(this));
    }
  }

  setupGetInspredGrid() {
    const el = this.blogWrapper;
    if (el.lengtth == 0) {
      return;
    }

    var currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    const items = this.blogElement;
    const lastItem = items[items.length - 1];
    if (items.length == 0) {
      return;
    }

    const itemWidth = lastItem.offsetWidth;
    let maxItemHeight = lastItem.offsetHeight;
    const numberOfCols = Math.floor(currentClientWidth / itemWidth);
    const numberOfRows = Math.floor(items.length / numberOfCols);

    let isSmall = false;
    let rowTemp = 0;
    let maxHeight = 0;
    items.forEach((item, i) => {
      let rowHeiht = 0;

      const element = item;
      const elementHeight = element.offsetHeight;

      const col = i % numberOfCols;
      const row = Math.floor(i / numberOfCols);

      /*calculate height of row, global max item height */
      if (row > 0) {
        for (let i = 1; i <= row; i++) {
          const preParalelIndex = col + (i - 1) * numberOfCols;
          const paralelEl = items[preParalelIndex];
          rowHeiht = rowHeiht + paralelEl.offsetHeight;

          maxItemHeight = maxItemHeight < paralelEl.offsetHeight ? paralelEl.offsetHeight : maxItemHeight;
        }

        maxHeight = maxHeight < rowHeiht ? rowHeiht : maxHeight;
      }

      /* initialize is small flag for that row */
      if (row !== rowTemp) {
        rowTemp = row;

        isSmall = row % 2 != 0;
      }

      const left = col * itemWidth;

      const top = rowHeiht.toFixed(2);

      if (top !== 'NaN') {
        const isHidden = false; //row > numberOfRows-2 && col%2 == 0; //hidden last two blog posts, owerflow problem

        if (!isHidden) {
          const padding = isSmall ? `${90 + Math.random() * 20}%` : `${110 + Math.random() * 40}%`;

          item.querySelector('.BlogItem--Wrapper').style.paddingTop = padding + 'px';

          const myitem = item;
          myitem.style.cssText = 'left:' + left + 'px;top:' + top + 'px';
          myitem.classList.add('BlogArticleItem--show');
          isSmall = !isSmall;
        }
      }
    });

    var elHeight = parseInt(maxHeight) + parseInt(maxItemHeight);
    el.style.cssText = 'width:' + numberOfCols * itemWidth + 'px;height:' + elHeight + 'px;margin:auto';
  }
}
customElements.define('blog-section', BlogSection);

class Account extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.order = this.element.querySelectorAll('.order-Wrapper');

    this.openOrderBtn = this.element.querySelector('#openOrder');
    this.openHitoryBtn = this.element.querySelector('#historyOrder');

    this.searchBar = this.element.querySelector('#searchBar');

    new Popup(this.element);

    this.isOpen = false;

    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on('click', '[data-action="toggle-active-orders"]', this.showActiveOrders.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-history-orders"]', this.showHistoryOrders.bind(this));
    this.delegateElement.on('keyup', '[data-action="searchItem"]', this.search.bind(this));
    this.delegateElement.on('click', '.agree_label', this.toggleButton.bind(this));
    this.delegateElement.on('click', '.agree__label', this.toggle_Button.bind(this));
  }

  toggleButton() {
    var id = event.target.getAttribute('for');
    var stateOfButton = this.element.querySelector('#' + id).checked;
    if (stateOfButton == true) {
      this.element.querySelector('.notAgree').style.display = 'none';
      this.element.querySelector('.iAgree').style.display = 'block';
    } else {
      this.element.querySelector('.notAgree').style.display = 'block';
      this.element.querySelector('.iAgree').style.display = 'none';
    }
  }
  toggle_Button() {
    var id = event.target.getAttribute('for');

    var stateOfButton = this.element.querySelector('#' + id).checked;
    if (stateOfButton == true) {
      this.element.querySelector('.notAgree2').style.display = 'none';
      this.element.querySelector('.iAgree2').style.display = 'block';
    } else {
      this.element.querySelector('.notAgree2').style.display = 'block';
      this.element.querySelector('.iAgree2').style.display = 'none';
    }
  }

  showActiveOrders() {
    this.order.forEach(function (getOrder) {
      if (getOrder.getAttribute('data-order-status') == 'fulfilled') {
        getOrder.classList.add('hidden');
      }
    });
    this.openOrderBtn.classList.add('active');
    this.openHitoryBtn.classList.remove('active');
  }
  showHistoryOrders() {
    this.order.forEach(function (getOrder) {
      if (getOrder.getAttribute('data-order-status') == 'fulfilled') {
        getOrder.classList.remove('hidden');
      }
    });
    this.openOrderBtn.classList.remove('active');
    this.openHitoryBtn.classList.add('active');
  }
  search() {
    let input = document.getElementById('searchBar').value;
    input = input.toLowerCase();

    var searchableItems = this.element.querySelectorAll('.order-Wrapper');
    var i = 0;

    for (i = 0; i < searchableItems.length; i++) {
      if (!searchableItems[i].innerHTML.toLowerCase().includes(input)) {
        searchableItems[i].style.display = 'none';
      } else {
        searchableItems[i].style.display = 'block';
      }
    }
  }
}
customElements.define('account-component', Account);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.searchElement = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.queryMap = {};
    this.searchResultsElement = this.element.querySelector('.SearchInitial');
    this.pageOverlayElement = document.querySelector('.pageOverlay');
    this.options = JSON.parse(this.element.getAttribute('data-settings'));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    if (window.theme.showSuggestedSearches) {
      this.getSuggestedSearches();
    }
    this.carouselElement = this.element.querySelector('.SearchCollection');
    if (this.carouselElement) {
      if (new Responsive().matchesBreakpoint('lap-and-up')) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }
    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.bindEvents();
  }

  bindEvents() {
    this._preventSubmissionListener = this.preventSubmission.bind(this);
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateElement.on('click', '[data-action="open-search"]', this.openSearch.bind(this));
    this.delegateElement.on('click', '[data-action="close-search"]', this.closeSearch.bind(this));
    this.searchInputElement.addEventListener('keydown', this._preventSubmissionListener);
    this.searchInputElement.addEventListener('input', this._onInputListener);
    this.delegateElement.on('click', '[data-action="search-string"]', this.onInput.bind(this));
    this.delegateElement.on('click', '[data-action="clear-search"]', this.clearSearch.bind(this));
    this.delegateBody.on('closeSearch', this.closeSearch.bind(this));
  }

  clearSearch() {
    this.searchInputElement.value = '';
  }

  initCarousel() {
    if (new Responsive().matchesBreakpoint('lap-and-up')) {
      var carousel = this.searchResultsElement.querySelector('[data-swiper-settings]');
      if (carousel) {
        this.newCarousel = new RevolutionSwiper(carousel);
      }
    }
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  openSearch() {
    event.preventDefault();
    if (this.isOpen) {
      this.closeSearch();
      return;
    }
    var _this = this;
    var target = event.target;
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;
    if (!this.searchElement.querySelector('.SearchSlide ') && this.options['product'] && this.options['collection'] == '') {
      this.loadRecommendations();
    }
    target.parentElement.querySelector('.SearchWrapper').setAttribute('aria-hidden', false);
    _this.pageOverlayElement.classList.add('is-visible');
    // Commented out to fix search scroll. Remove it if everything is working as it should.
    // document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    if (!isMobile) document.body.style.overflow = 'hidden';
    _this.closeListener = _this.closeSearch.bind(this);
    _this.pageOverlayElement.addEventListener('click', _this.closeListener);

    this.element.dispatchEvent(new CustomEvent('openSearch', { bubbles: true }));
    // Commented out to fix search scroll. Remove it if everything is working as it should.
    // bodyScrollLock.disableBodyScroll(_this.searchElement.querySelector('[data-scrollable]'));
    this.isOpen = true;
    this.searchElement.querySelector('.SearchInput').focus();
    document.body.querySelector('#shopify-section-header').style.zIndex = '99';
    if (_this.options['transparent']) {
      setTimeout(() => {
        document.body.querySelector('#header').classList.remove('Header--Transparent');
      }, 15);
    }
  }

  closeSearch() {
    event.preventDefault();
    var _this = this;
    if (!this.isOpen) {
      return;
    }
    bodyScrollLock.enableBodyScroll(_this.searchElement);
    document.body.querySelector('#shopify-section-header').style.zIndex = '6';
    document.body.querySelectorAll('.SearchWrapper').forEach((item, i) => {
      item.setAttribute('aria-hidden', true);
    });
    _this.pageOverlayElement.classList.remove('is-visible');
    document.body.querySelector('#shopify-section-header').style.backgroundColor = 'transparent';
    document.body.style.position = 'relative';
    document.body.style.width = '100%';
    document.body.style.overflow = 'auto';
    if (_this.options['transparent']) {
      document.body.querySelector('#header').classList.add('Header--Transparent');
    }
    this.resetSearch();
    this.isOpen = false;
  }

  preventSubmission(event) {
    if (event.keyCode === 13 && window.theme.searchMode !== 'product') {
      event.preventDefault();
    }
  }

  onInput(event) {
    this.lastInputValue = event.target.value;
    var passTrough = false;
    var _this = this;
    this.searchResultsElement.style.opacity = 0;
    if (event.target.getAttribute('value') && _this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute('value');
      const el = _this.searchElement.querySelector('.SearchInput');
      passTrough = true;
      el.setAttribute('value', _this.lastInputValue);
      el.value = _this.lastInputValue;
    } else {
      if (event.keyCode === 13) {
        return;
      }

      if (this.lastInputValue === '') {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    var queryOptions = {
      method: 'GET',
      credentials: 'same-origin',
    };

    var queries = [fetch('/search?view=ajax&q=' + encodeURIComponent(this.lastInputValue) + '*&type=product', queryOptions)];

    if (window.theme.searchMode !== 'product') {
      queries.push(
        fetch(
          '/search?view=ajax&q=' + encodeURIComponent(this.lastInputValue) + '*&type=' + window.theme.searchMode.replace('product,', ''),
          queryOptions
        )
      );
    }

    this.queryMap[this.lastInputValue] = true;

    Promise.all(queries).then(function (responses) {
      if (_this.lastInputValue !== event.target.value && passTrough == false) {
        return;
      }
      delete _this.queryMap[event.target.value];

      Promise.all(
        responses.map(function (response) {
          return response.text();
        })
      ).then(function (contents) {
        var rValueA = [],
          rValue,
          searchResult = '';
        contents.forEach((item) => {
          if (item.includes('sr_count')) {
            rValueA.push(true);
          } else {
            rValueA.push(false);
          }
        });

        if (rValueA.includes(false)) {
          rValue = false;
        } else {
          rValue = true;
        }

        function searchMode() {
          if (window.theme.searchMode === 'disabled') return;

          if (window.theme.searchMode === 'product') {
            if (_this.options['suggestedCollections']) {
              searchResult =
                '<div class="SearchLayout--twoOptions">\n' +
                contents[0] +
                '<div class="SearchLayout__Section SearchLayout__Section--collections" data-animation="elementFromBottom"></div></div>';
            } else {
              searchResult = contents[0];
            }
          } else if (rValue == false) {
            let tempElement = document.createElement('div');
            tempElement.innerHTML = contents[0];
            if (rValueA[0] == true) {
              var result = tempElement.querySelector('#noResultProducts');
            } else {
              var result = tempElement;
            }
            if (_this.options['suggestedCollections']) {
              if (result.getAttribute('id') === 'noResultProducts') {
                result.innerHTML = `    <div class="SearchSegmentHeader">
                                <span class="Segment__Title Search_View--actions u-h5">Products</span>
                                  </div><p class="SegmentNoResult  u-p5">${window.languages.no_results}</p></div>`;
              }
              searchResult =
                '<div class="SearchLayout">\n<div class="SearchLayout__Section SearchLayout__Section--Products">' +
                result.innerHTML +
                '</div>\n  <div class="SearchLayout__Section SearchLayout__Section--collections" data-animation="elementFromBottom"></div>\n<div class="SearchLayout__Section SearchLayout__Section--secondary">' +
                contents[1] +
                '</div>\n</div>';
            } else {
              searchResult =
                '<div class="SearchLayout--twoOptions">\n<div class="SearchLayout__Section SearchLayout__Section--Products">' +
                result.innerHTML +
                '</div>\n<div class="SearchLayout__Section SearchLayout__Section--secondary">' +
                contents[1] +
                '</div>\n</div>';
            }
          } else {
            let tempElement = document.createElement('div');
            tempElement.innerHTML = contents[0];
            let result = tempElement.querySelector('#noResultAll');
            searchResult = '<div class="SearchLayout__Section Search--Recommendations-noResults">' + result.innerHTML + '</div>\n ';
          }
        }

        searchMode();

        _this.loadData(_this.lastInputValue, rValue, searchResult, event, contents);
      });
    });
  }

  loadData(query, rValue, searchResult, eventValue, contents) {
    var _this = this,
      collectionInner = '';
    this.element.querySelector('.SearchInitial').style.display = 'flex';
    this.element.querySelector('.SearchInitial').classList.add('SearchInitial--SecondView');

    if (_this.options['suggestedCollections']) {
      return fetch(window.routes.localeRootUrl + '/search/suggest.json?q=' + query + '&resources[type]=collection&resources[limit]=1')
        .then((response) => response.json())
        .then((suggestions) => {
          const collectionSuggestions = suggestions.resources.results.collections;

          if (collectionSuggestions) {
            if (rValue == true) {
              searchResult =
                '<div class="SearchLayout">\n<div class="SearchLayout__Section SearchLayout__Section--Products"><div class="SearchSegmentHeader"><span class="Segment__Title Search_View--actions u-h5">Products</span></div><p class="SegmentNoResult  u-p5">' +
                window.languages.no_results +
                '</p></div>\n  <div class="SearchLayout__Section SearchLayout__Section--collections" data-animation="elementFromBottom"></div>\n<div class="SearchLayout__Section SearchLayout__Section--secondary">' +
                contents[1] +
                '</div>\n</div>';
            }
            _this.searchResultsElement.innerHTML = searchResult;
            var collectionHTML =
              '<div class="SearchSegmentHeader"><span class="Segment__Title Search_View--actions u-h5 primary-text">' +
              window.languages.collections +
              '</span><a class="u-p3 SearchHeader--Primary" href="/search?q=' +
              query +
              '*&amp;type=product">' +
              '</a></div><div class="Segment__Content"></div>';
            _this.searchElement.querySelector('.SearchLayout__Section--collections').innerHTML = collectionHTML;
            collectionSuggestions.forEach(function (entry) {
              collectionInner =
                collectionInner +
                '<a href=' +
                entry.url +
                ' class="CollectionSearchItem SearchSlide animatedContent AspectRatio AspectRatio--withFallback" style="--aspect-ratio: 1.249;"><img src=' +
                entry.featured_image.url +
                ' class="SearchCollectionImage"><div class="SearchCollectionContent"><h5 class="u-h3 mb-s">' +
                entry.title +
                '</h5></div></a>';
            });
            _this.searchElement.querySelector('.SearchLayout__Section--collections .Segment__Content').innerHTML = collectionInner;
          } else if (!collectionSuggestions && rValue == false) {
            _this.searchResultsElement.innerHTML = searchResult;
            _this.searchElement.querySelector('.SearchLayout__Section--collections').innerHTML =
              '<div class="SearchSegmentHeader"><span class="Segment__Title Search_View--actions u-h5 primary-text">' +
              window.languages.collections +
              '</span></div><div class="Segment__Content"><p class="SegmentNoResult primary-text u-p4">' +
              window.languages.no_results +
              '</p></div>';
          } else {
            if (this.options['noResultcollection']) {
              _this.searchResultsElement.innerHTML =
                '<div class="SearchLayout__Section Search--Recommendations-noResults">' + contents[0] + '</div>\n ';
            } else {
              _this.searchResultsElement.innerHTML =
                '<div class="SearchLayout__Section Search--no_resultsCenter">' + searchResult + '</div>\n ';
            }
          }
          if (this.options['product'] && this.options['collection'] == '') {
            _this.loadRecommendations();
          }
          if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
            new RevolutionAnimation(_this.searchResultsElement);
          }
          _this.searchResultsElement.setAttribute('aria-hidden', 'false');
          if (window.theme.showRecentSearches) {
            _this.recentSearches(eventValue);
          }
          _this.initCarousel();
          _this.searchResultsElement.style.opacity = 1;
        });
    } else {
      this.searchResultsElement.innerHTML = searchResult;
    }
    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(_this.searchResultsElement);
    }
    _this.searchResultsElement.setAttribute('aria-hidden', 'false');
    if (window.theme.showRecentSearches) {
      _this.recentSearches(eventValue);
    }
    _this.initCarousel();
    _this.searchResultsElement.style.opacity = 1;
  }

  loadRecommendations() {
    var _this = this,
      product_to_search = _this.options['product'],
      url = '/recommendations/products?section_id=search_suggested&product_id=' + product_to_search + '&limit=8';

    return fetch(url).then(function (response) {
      return response.text().then(function (content) {
        var container = document.createElement('div');
        var contentjq = document.createElement('div');
        contentjq.innerHTML = content;
        container.innerHTML = contentjq.innerHTML;
        const newSwiper = _this.element.querySelector('.SearchInitial--Products');
        newSwiper.innerHTML = container.querySelector('.ProductRecommendations').innerHTML;
        _this.initCarousel();
        if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
          new RevolutionAnimation(newSwiper);
        }
        new AddToCart(_this.element);
      });
    });
  }
  resetSearch() {
    this.element.querySelector('.SearchInitial').classList.remove('SearchInitial--SecondView');
    this.initialSearchLayout.querySelector('.SearchInitial--Recents').style.opacity = 0;
    if (this.initialSearchLayout.querySelector('.SearchInitial--Products')) {
      this.initialSearchLayout.querySelector('.SearchInitial--Products').style.opacity = 0;
    }

    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;

    const el = this.searchElement.querySelector('.Search__Form');
    el.value = '';
    el.removeAttribute('value');
    this.searchResultsElement.setAttribute('aria-hidden', 'false');
    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    if (window.theme.showSuggestedSearches) {
      this.getSuggestedSearches();
    }
    if (this.options['product'] && this.options['collection'] == '') {
      this.loadRecommendations();
    }
    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.element.querySelector('.SearchInitial').style.display = 'flex';
    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
    this.searchResultsElement.querySelector('.SearchInitial--Recents').style.opacity = 1;
    if (this.initialSearchLayout.querySelector('.SearchInitial--Products')) {
      this.initialSearchLayout.querySelector('.SearchInitial--Products').style.opacity = 1;
    }
  }

  recentSearches(event) {
    this.searchResultsElement.style.opacity = 0;
    var _this = this;
    this.lastInputValue = event.target.value;
    if (this.lastInputValue === '') {
      this.initialSearchLayout.style.opacity = 0;
      this.resetSearch();
      return;
    }

    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem('searchTerms') || '[]');
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem('searchTerms', JSON.stringify(searchTerm.slice(0, 5)));
      } catch (error) {}
    }
  }

  getRecentSearches() {
    var appendString = '';
    var items = JSON.parse(localStorage.getItem('searchTerms') || '[]');
    var appElement = this.searchElement.querySelector('.Search--Recent__results');
    if (items.length > 0) {
      items.forEach((id, index) => {
        appendString = appendString + "<li tabIndex='0' class='pt-m pb-m' data-action='search-string' value='" + id + "'>" + id + '</li>';
      });

      appElement.innerHTML = appendString;
    } else {
      var appEl = this.searchElement.querySelector('.Search--Recent');
      appEl.style.display = 'none';
    }
  }
  getSuggestedSearches() {
    var appendString = '';
    const arr = this.options.items;
    arr.sort(function () {
      return 0.5 - Math.random();
    });
    var filtred = arr.filter(function (a) {
      if (!a.includes('_')) {
        return a;
      }
    });

    var i;
    appendString = '';
    for (i = 0; i < 5; i++) {
      if (filtred[i]) {
        var filteredResult = filtred[i].replace(':', ' ');
        filteredResult = filteredResult.replace('-', ' ');
        appendString =
          appendString +
          "<li tabindex='0' class='pt-m pb-m' data-action='search-string' value='" +
          filteredResult +
          "'>" +
          filteredResult +
          '</li>';
      }
    }
    var appElement = this.searchElement.querySelector('.Search--Suggested__results');
    appElement.innerHTML = appendString;
  }
}
customElements.define('search-bar', SearchBar);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }
    new Popup(this.element);
    this.isOpen = false;
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on('change', '#agree', this.toggleButton.bind(this));
  }

  toggleButton() {
    var stateOfButton = event.target.checked;
    if (stateOfButton == true) {
      this.element.querySelector('.Contact-Btn').removeAttribute('disabled');
    } else {
      this.element.querySelector('.Contact-Btn').setAttribute('disabled', true);
    }
  }
}
customElements.define('contact-section', ContactSection);

class CollectionGrid extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    new AddToCart(this.element);

    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }
  }
}
customElements.define('collection-grid', CollectionGrid);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
    };
    this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute('available')) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() {}

  renderPreview(sectionInnerHTML) {
    if (this.element.innerHTML == '') {
      this.element.appendChild(sectionInnerHTML.querySelector('#LocalPickup'));
      this.element.appendChild(sectionInnerHTML.querySelector('.LocalPickup__Wrapper'));
      new Drawer(this.element.querySelector('#LocalPickup'));
    } else {
      this.element.querySelector('#LocalPickup').innerHTML = sectionInnerHTML.querySelector('#LocalPickup').innerHTML;
      this.element.querySelector('.LocalPickup__Wrapper').innerHTML = sectionInnerHTML.querySelector('.LocalPickup__Wrapper').innerHTML;
    }
  }
}

customElements.define('pickup-availability', PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.value = this.element.querySelector('textarea').value;
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on('click', "[data-action='update-note']", this.updateNote.bind(this));
  }
  updateNote() {
    fetch(`${window.routes.localeRootUrl}/update.js`, {
      body: JSON.stringify({ note: this.value }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function () {});
  }
}

customElements.define('cart-note', CartNote);

class NewSwiper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.carouselElement = this.element.querySelector('.swiper');
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define('swiper-section', NewSwiper);

class SwiperNoDesk extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.carouselElement = this.element.querySelector('.swiper');
    if (this.element.classList.contains('FooterDeliveryBar') != true) {
      let breakpoint = new Responsive().getCurrentBreakpoint();
      if (breakpoint == 'phone' || breakpoint == 'tablet') {
        new RevolutionSwiper(this.element.querySelector('.swiper'));
      }
    }
  }
}
customElements.define('swiper-mobile', SwiperNoDesk);

class Subcategory_swiper_wrapper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.carouselElement = this.element.querySelector('.swiper');
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define('subcategories-carousel', Subcategory_swiper_wrapper);

class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    var selectBoxes = this.element.querySelectorAll('.RevolutionDropdown');
    var location = this.element.getAttribute('data-settings');
    this.delegateElement.on('change', '[data-action="country-change"]', this.submitForm.bind(this));
    if (location == 'sidebarMenu') {
      var additionalOverlay = true;
    } else {
      var additionalOverlay = false;
    }
    if (breakpoint != 'phone' && breakpoint != 'tablet') {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item);
        });
      }
    } else {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item, true, additionalOverlay);
        });
      }
    }
  }

  submitForm() {
    event.target.closest('form').submit();
  }
}

class AnimationWrapper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
      new RevolutionAnimation(this.element);
    }
  }
}
customElements.define('animation-wrapper', AnimationWrapper);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector('.pageOverlay');

    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

    this.handleOpenOptions();
    if (this.options.edit_mode == true) {
      this.options.delay = 0;
      this.openNewsletter();
    }
  }

  handleOpenOptions() {
    let sessionKey = sessionStorage.getItem('popup-seen');
    var localKey = localStorage.getItem('popup-seen');

    if (this.options.show_only_once == true && localKey == 'true') {
      return;
    }
    if (sessionKey != 'true') {
      if (this.options.scroll_amount > 0) {
        this.scrollListener = this.scrollListener.bind(this);
        document.addEventListener('scroll', this.scrollListener);
      } else {
        this.openNewsletter();
      }
    }
  }

  scrollListener() {
    var _this = this,
      body = document.body,
      html = document.documentElement;
    let docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    let percScrolled = (window.scrollY / docHeight) * 100;
    if (percScrolled >= _this.options.scroll_amount) {
      _this.openNewsletter();
    }
  }

  openNewsletter() {
    var _this = this;
    setTimeout(() => {
      this.element.setAttribute('aria-hidden', false);
      this.pageOverlayElement.classList.add('is-visible');
      bodyScrollLock.disableBodyScroll(this.element);
      this.onClickOutsideListener = this.closeNewsletter.bind(this);
      this.pageOverlayElement.addEventListener('click', this.onClickOutsideListener);
      sessionStorage.setItem('popup-seen', true);
      localStorage.setItem('popup-seen', true);
      this.delegateElement.on('click', '[data-action="close-modal"]', this.closeNewsletter.bind(this));
    }, 1000 * _this.options.delay);
  }

  closeNewsletter() {
    this.element.setAttribute('aria-hidden', true);
    this.pageOverlayElement.classList.remove('is-visible');
    bodyScrollLock.clearAllBodyScrollLocks();
    this.pageOverlayElement.removeEventListener('click', this.onClickOutsideListener);
    document.removeEventListener('scroll', this.scrollListener);
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
